module.exports = __webpack_public_path__ + "static/img/7.394a9d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/7.png
// module id = qg4A
// module chunks = 0